import React from "react";
import { Route } from "react-router-dom";
import IconLibrary from "../pages/StyleGuide/IconLibrary/IconLibrary";
import QuoteTableStyleGuide from "../pages/StyleGuide/QuoteTableStyleGuide/QuoteTableStyleGuide";
import StyleGuide from "../pages/StyleGuide/StyleGuide";
import StyleGuideComponents from "../pages/StyleGuide/StyleGuideComponents/StyleGuideComponents";

interface IStyleGuideRoutes {
    base: string;
}

const StyleGuideRoutes: React.FC<IStyleGuideRoutes> = ({ base }) => {
    return (
        <React.Fragment>
            <Route exact path={`${base}/quote-table`}>
                <QuoteTableStyleGuide />
            </Route>

            <Route exact path={`${base}/components`}>
                <StyleGuideComponents />
            </Route>

            <Route exact path={`${base}/icon-library`}>
                <IconLibrary />
            </Route>

            <Route exact path={base}>
                <StyleGuide />
            </Route>
        </React.Fragment>
    );
};

export default StyleGuideRoutes;
